import FilterRequest from '../../../../../Spirit/Common/Extensions/Models/FilterRequest';

export default class AudioFileAlbumCategoryRequest extends FilterRequest {
	
	constructor(obj?: Partial<AudioFileAlbumCategoryRequest>) {
		super(obj);
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
